<!-- Main Banner -->
<div class="home-wrapper-area">
    <div class="home-slides owl-carousel owl-theme">
        <div class="main-slider-item">
            <div class="d-table">
                <div class="d-table-cell">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-6 col-md-12">
                                <div class="main-slider-content">
                                    <h1>We Move The  Digital Industrial Forward</h1>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                    <div class="slider-btn">
                                        <a routerLink="/" class="default-btn">Get Services</a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="main-slider-image"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-slider-item">
            <div class="d-table">
                <div class="d-table-cell">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-6 col-md-12">
                                <div class="main-slider-content">
                                    <h1>We Provide Digital Marketing Solutions</h1>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                    <div class="slider-btn">
                                        <a routerLink="/" class="default-btn">Get Services</a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="main-slider-image two"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-slider-item">
            <div class="d-table">
                <div class="d-table-cell">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-6 col-md-12">
                                <div class="main-slider-content">
                                    <h1>Digital Agency with Excellence Service</h1>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                                    <div class="slider-btn">
                                        <a routerLink="/" class="default-btn">Get Services</a>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="main-slider-image three"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="main-slider-shape">
        <div class="shape-1"><img src="assets/img/main-slider/slider-shape-1.png" alt="image"></div>
        <div class="shape-2"><img src="assets/img/main-slider/slider-shape-2.png" alt="image"></div>
        <div class="shape-3"><img src="assets/img/main-slider/slider-shape-3.png" alt="image"></div>
        <div class="shape-4"><img src="assets/img/main-slider/slider-shape-4.png" alt="image"></div>
    </div>
</div>
<!-- End Main Banner -->

<!-- Features -->
<section class="features-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="single-features">
                    <div class="icon">
                        <i class="flaticon-promotion"></i>
                    </div>
                    <h3><a routerLink="/services-details">Marketing Analysis</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                    <div class="number">
                        <span>1</span>
                    </div>
                    <div class="shape"><img src="assets/img/features-shape/features-shape-1.png" alt="image"></div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-features">
                    <div class="icon">
                        <i class="flaticon-speed"></i>
                    </div>
                    <h3><a routerLink="/services-details">Website Optimization</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                    <div class="number">
                        <span>2</span>
                    </div>
                    <div class="shape"><img src="assets/img/features-shape/features-shape-1.png" alt="image"></div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-features">
                    <div class="icon">
                        <i class="flaticon-email"></i>
                    </div>
                    <h3><a routerLink="/services-details">Email Marketing</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                    <div class="number">
                        <span>3</span>
                    </div>
                    <div class="shape"><img src="assets/img/features-shape/features-shape-1.png" alt="image"></div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-features">
                    <div class="icon">
                        <i class="flaticon-network"></i>
                    </div>
                    <h3><a routerLink="/services-details">Social Media Marketing</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>
                    <div class="number">
                        <span>4</span>
                    </div>
                    <div class="shape"><img src="assets/img/features-shape/features-shape-1.png" alt="image"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Features -->

<!-- Services -->
<section class="services-area bg-fafafa pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Our Digital Marketing Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-code"></i>
                    </div>
                    <h3><a routerLink="/services-details">Website Development</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incutu  labore et dolore magna aliqua.</p>
                    <a routerLink="/services-details" class="services-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-vector"></i>
                    </div>
                    <h3><a routerLink="/services-details">Web Design</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incutu  labore et dolore magna aliqua.</p>
                    <a routerLink="/services-details" class="services-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-network"></i>
                    </div>
                    <h3><a routerLink="/services-details">Social Media Marketing</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incutu  labore et dolore magna aliqua.</p>
                    <a routerLink="/services-details" class="services-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-search"></i>
                    </div>
                    <h3><a routerLink="/services-details">Content Marketing</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incutu  labore et dolore magna aliqua.</p>
                    <a routerLink="/services-details" class="services-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-digital-marketing-1"></i>
                    </div>
                    <h3><a routerLink="/services-details">Digital Media & PPC</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incutu  labore et dolore magna aliqua.</p>
                    <a routerLink="/services-details" class="services-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-box">
                    <div class="icon">
                        <i class="flaticon-cpu"></i>
                    </div>
                    <h3><a routerLink="/services-details">Technology</a></h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incutu  labore et dolore magna aliqua.</p>
                    <a routerLink="/services-details" class="services-btn">Read More <i class="flaticon-right-arrow"></i></a>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape1"><img src="assets/img/default-shape/default-shape1.png" alt="image"></div>
        <div class="shape2"><img src="assets/img/default-shape/default-shape2.png" alt="image"></div>
        <div class="shape3"><img src="assets/img/default-shape/default-shape3.png" alt="image"></div>
        <div class="shape4"><img src="assets/img/default-shape/default-shape4.png" alt="image"></div>
    </div>
</section>
<!-- End Services -->

<!-- About -->
<section class="about-area ptb-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <div class="about-image-warp image-two"></div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="about-content warp">
                    <span>About Us</span>
                    <h3>We Help Companies to Generate Leads and Increase in Sales</h3>
                    <div class="bar"></div>
                    <strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt labore  dolore magna aliqua.</strong>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.</p>
                    <div class="about-btn">
                        <a routerLink="/about-1" class="default-btn">Learn More</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>   
<!-- End About -->

<!-- Portfolio -->
<section class="portfolio-area pb-100">
    <div class="container-fluid">
        <div class="section-title">
            <span>Portfolio Showcase</span>
            <h2>Our Impressive Portfolio</h2>
            <div class="bar"></div>
        </div>

        <div class="portfolio-slider owl-carousel owl-theme">
            <div class="single-portfolio-item">
                <div class="portfolio-image">
                    <a routerLink="/portfolio-details">
                        <img src="assets/img/portfolio/portfolio-1.jpg" alt="image">
                    </a>
                </div>
                <div class="portfolio-content">
                    <h3><a routerLink="/portfolio-details">Creative Work</a></h3>
                    <span>Web Design</span>
                </div>
            </div>

            <div class="single-portfolio-item">
                <div class="portfolio-image">
                    <a routerLink="/portfolio-details">
                        <img src="assets/img/portfolio/portfolio-9.jpg" alt="image">
                    </a>
                </div>
                <div class="portfolio-content">
                    <h3><a routerLink="/portfolio-details">Ecommerce Work</a></h3>
                    <span>Creative Agency</span>
                </div>
            </div>

            <div class="single-portfolio-item">
                <div class="portfolio-image">
                    <a routerLink="/portfolio-details">
                        <img src="assets/img/portfolio/portfolio-3.jpg" alt="image">
                    </a>
                </div>
                <div class="portfolio-content">
                    <h3><a routerLink="/portfolio-details">App Development</a></h3>
                    <span>IOS Android</span>
                </div>
            </div>

            <div class="single-portfolio-item">
                <div class="portfolio-image">
                    <a routerLink="/portfolio-details">
                        <img src="assets/img/portfolio/portfolio-4.jpg" alt="image">
                    </a>
                </div>
                <div class="portfolio-content">
                    <h3><a routerLink="/portfolio-details">Dashboard App</a></h3>
                    <span>Web Development</span>
                </div>
            </div>

            <div class="single-portfolio-item">
                <div class="portfolio-image">
                    <a routerLink="/portfolio-details">
                        <img src="assets/img/portfolio/portfolio-5.jpg" alt="image">
                    </a>
                </div>
                <div class="portfolio-content">
                    <h3><a routerLink="/portfolio-details">Web Application</a></h3>
                    <span>Marketing</span>
                </div>
            </div>

            <div class="single-portfolio-item">
                <div class="portfolio-image">
                    <a routerLink="/portfolio-details">
                        <img src="assets/img/portfolio/portfolio-6.jpg" alt="image">
                    </a>
                </div>
                <div class="portfolio-content">
                    <h3><a routerLink="/portfolio-details">Logo & Branding</a></h3>
                    <span>Agency</span>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Portfolio -->

<!-- Pricing -->
<section class="pricing-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Pricing Plans</span>
            <h2>The Best Solutions for Our Clients</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-pricing-box top-1">
                    <div class="pricing-header">
                        <h3>Basic Plan</h3>
                    </div>

                    <div class="price">
                        $24
                    </div>

                    <ul class="pricing-features">
                        <li><i class="flaticon-check-mark"></i> SEO Audits</li>
                        <li><i class="flaticon-check-mark"></i> SEO Management</li>
                        <li><i class="flaticon-check-mark"></i> SEO Copywriting</li>
                        <li><i class="flaticon-check-mark"></i> Link Building</li>
                        <li><i class="flaticon-check-mark"></i> Site Migration</li>
                        <li><i class="flaticon-check-mark"></i> Video Camplaigns</li>
                        <li><i class="flaticon-check-mark"></i> Unlimited SEO Keywords</li>
                    </ul>

                    <div class="pricing-btn">
                        <a routerLink="/" class="default-btn">Get Started</a>
                    </div>

                    <div class="pricing-shape"><img src="assets/img/pricing-shape.png" alt="image"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-pricing-box">
                    <div class="pricing-header">
                        <h3>Standard Plan</h3>
                    </div>

                    <div class="price">
                        $59
                    </div>

                    <ul class="pricing-features">
                        <li><i class="flaticon-check-mark"></i> SEO Audits</li>
                        <li><i class="flaticon-check-mark"></i> SEO Management</li>
                        <li><i class="flaticon-check-mark"></i> SEO Copywriting</li>
                        <li><i class="flaticon-check-mark"></i> Link Building</li>
                        <li><i class="flaticon-check-mark"></i> Site Migration</li>
                        <li><i class="flaticon-check-mark"></i> Video Camplaigns</li>
                        <li><i class="flaticon-check-mark"></i> Unlimited SEO Keywords</li>
                    </ul>

                    <div class="pricing-btn">
                        <a routerLink="/" class="default-btn">Get Started</a>
                    </div>

                    <div class="pricing-shape"><img src="assets/img/pricing-shape.png" alt="image"></div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-pricing-box top-2">
                    <div class="pricing-header">
                        <h3>Premium Plan</h3>
                    </div>

                    <div class="price">
                        $89
                    </div>

                    <ul class="pricing-features">
                        <li><i class="flaticon-check-mark"></i> SEO Audits</li>
                        <li><i class="flaticon-check-mark"></i> SEO Management</li>
                        <li><i class="flaticon-check-mark"></i> SEO Copywriting</li>
                        <li><i class="flaticon-check-mark"></i> Link Building</li>
                        <li><i class="flaticon-check-mark"></i> Site Migration</li>
                        <li><i class="flaticon-check-mark"></i> Video Camplaigns</li>
                        <li><i class="flaticon-check-mark"></i> Unlimited SEO Keywords</li>
                    </ul>

                    <div class="pricing-btn">
                        <a routerLink="/" class="default-btn">Get Started</a>
                    </div>

                    <div class="pricing-shape"><img src="assets/img/pricing-shape.png" alt="image"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Pricing -->

<!-- Team -->
<section class="team-area pb-100">
    <div class="container-fluid">
        <div class="section-title">
            <span>Team Member</span>
            <h2>Our Expert Team</h2>
            <div class="bar"></div>
        </div>
        
        <div class="team-slider owl-carousel owl-theme">
            <div class="single-team">
                <div class="image">
                    <img src="assets/img/team/team-1.jpg" alt="image">
                
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>

                    <div class="content">
                        <h3>Justin Roberto</h3>
                        <span>CEO & Founder</span>
                    </div>
                </div>
            </div>

            <div class="single-team">
                <div class="image">
                    <img src="assets/img/team/team-2.jpg" alt="image">
                
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>

                    <div class="content">
                        <h3>Jacinda Meri</h3>
                        <span>Web Developer</span>
                    </div>
                </div>
            </div>

            <div class="single-team">
                <div class="image">
                    <img src="assets/img/team/team-3.jpg" alt="image">
                
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>

                    <div class="content">
                        <h3>Miraj Alex</h3>
                        <span>Chief Executive Officer</span>
                    </div>
                </div>
            </div>

            <div class="single-team">
                <div class="image">
                    <img src="assets/img/team/team-4.jpg" alt="image">
                
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>

                    <div class="content">
                        <h3>Edward Bold</h3>
                        <span>UI/UX Designer</span>
                    </div>
                </div>
            </div>

            <div class="single-team">
                <div class="image">
                    <img src="assets/img/team/team-5.jpg" alt="image">
                
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>

                    <div class="content">
                        <h3>Alastair Cook</h3>
                        <span>Marketing Support</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Team -->

<!-- Fun Facts -->
<section class="fun-facts-area pb-70">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact-box">
                    <div class="icon">
                        <i class="flaticon-checked"></i>
                    </div>
                    <h3><span class="odometer" data-count="950">00</span></h3>
                    <p>Completed Project</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact-box">
                    <div class="icon">
                        <i class="flaticon-happy"></i>
                    </div>
                    <h3><span class="odometer" data-count="850">00</span></h3>
                    <p>Happy Clients</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact-box">
                    <div class="icon">
                        <i class="flaticon-technical-support"></i>
                    </div>
                    <h3><span class="odometer" data-count="550">00</span></h3>
                    <p>Multi Service</p>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-fun-fact-box">
                    <div class="icon">
                        <i class="flaticon-trophy"></i>
                    </div>
                    <h3><span class="odometer" data-count="750">00</span></h3>
                    <p>Winning Awards</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Fun Facts -->

<!-- Industries -->
<section class="industries-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span>Industries We Work For</span>
            <h2>Helping Businesses in All Domains</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-digital-marketing-2"></i>
                    <h3>Digital Marketing</h3>
                    <a routerLink="/"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-bank"></i>
                    <h3>Banking Services</h3>
                    <a routerLink="/"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-graduation-cap"></i>
                    <h3>Education Services</h3>
                    <a routerLink="/"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-stock-market"></i>
                    <h3>Business Consult</h3>
                    <a routerLink="/"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-employee"></i>
                    <h3>Entrepreneur</h3>
                    <a routerLink="/"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-waiter"></i>
                    <h3>Restaurant</h3>
                    <a routerLink="/"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-stethoscope"></i>
                    <h3>Health Services</h3>
                    <a routerLink="/"></a>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="single-industries-box">
                    <i class="flaticon-user"></i>
                    <h3>Social Network</h3>
                    <a routerLink="/"></a>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Industries -->

<!-- Client -->
<section class="client-area ptb-100">
    <div class="container">
        <div class="section-title">
            <span>Testimonials</span>
            <h2>Client’s Review</h2>
            <div class="bar"></div>
        </div>

        <div class="client-slider owl-carousel owl-theme">
            <div class="client-item">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley</p>
                <div class="client-info">
                    <img src="assets/img/client/client-1.jpg" alt="image">
                    <h3>Jacinda Meri</h3>
                    <span>CEO & Founder</span>
                </div>
            </div>

            <div class="client-item">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley</p>
                <div class="client-info">
                    <img src="assets/img/client/client-2.jpg" alt="image">
                    <h3>Miraj Alex</h3>
                    <span>Chief Executive Officer</span>
                </div>
            </div>

            <div class="client-item">
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley</p>
                <div class="client-info">
                    <img src="assets/img/client/client-3.jpg" alt="image">
                    <h3>Edward Bold</h3>
                    <span>Web Developer</span>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Client -->

<!-- Blog -->
<section class="blog-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <span>Blog</span>
            <h2>Latest News From Blog</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-blog">
                    <div class="image">
                        <a routerLink="/blog-details"><img src="assets/img/blog/blog-1.jpg" alt="image"></a>
                    </div>
                    <div class="content">
                        <span>20 March, 2020</span>
                        <h3><a routerLink="/blog-details">7 Great Tips For Earn More Money From Digital Industry</a></h3>
                        <a routerLink="/blog-details" class="blog-btn">Read More <i class='bx bx-chevrons-right'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-blog">
                    <div class="image">
                        <a routerLink="/blog-details"><img src="assets/img/blog/blog-2.jpg" alt="image"></a>
                    </div>
                    <div class="content">
                        <span>25 March, 2020</span>
                        <h3><a routerLink="/blog-details">How To Boost Your Digital Marketing Agency</a></h3>
                        <a routerLink="/blog-details" class="blog-btn">Read More <i class='bx bx-chevrons-right'></i></a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-blog">
                    <div class="image">
                        <a routerLink="/blog-details"><img src="assets/img/blog/blog-3.jpg" alt="image"></a>
                    </div>
                    <div class="content">
                        <span>28 March, 2020</span>
                        <h3><a routerLink="/blog-details">The Billionaire Guide On Design That will Get You Rich</a></h3>
                        <a routerLink="/blog-details" class="blog-btn">Read More <i class='bx bx-chevrons-right'></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape1"><img src="assets/img/default-shape/default-shape1.png" alt="image"></div>
        <div class="shape2"><img src="assets/img/default-shape/default-shape2.png" alt="image"></div>
        <div class="shape3"><img src="assets/img/default-shape/default-shape3.png" alt="image"></div>
        <div class="shape4"><img src="assets/img/default-shape/default-shape4.png" alt="image"></div>
    </div>
</section>
<!-- End Blog -->

<!-- Subscribe -->
<section class="subscribe-area ptb-100">
    <div class="container">
        <div class="subscribe-content">
            <span>Get Started Instantly!</span>
            <h2>Get Only New Update from this Newsletter</h2>
            <form class="newsletter-form" data-toggle="validator">
                <input type="email" class="input-newsletter" placeholder="Enter your email" name="EMAIL">
                <button type="submit">Subscribe</button>
            </form>
        </div>
    </div>
</section>
<!-- End Subscribe -->

<!-- Partner -->
<div class="partner-area ptb-100">
    <div class="container">
        <div class="partner-slider owl-carousel owl-theme">
            <div class="partner-item">
                <img src="assets/img/partner/partner-1.png" alt="image">
            </div>

            <div class="partner-item">
                <img src="assets/img/partner/partner-2.png" alt="image">
            </div>

            <div class="partner-item">
                <img src="assets/img/partner/partner-3.png" alt="image">
            </div>

            <div class="partner-item">
                <img src="assets/img/partner/partner-4.png" alt="image">
            </div>

            <div class="partner-item">
                <img src="assets/img/partner/partner-5.png" alt="image">
            </div>

            <div class="partner-item">
                <img src="assets/img/partner/partner-6.png" alt="image">
            </div>
        </div>
    </div>
</div>
<!-- End Partner -->